import React, { Fragment } from "react";
import { useOutletContext } from "react-router-dom";
import AdministrationHeader from "../../components/header-components/AdministrationHeader.jsx";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";



const OrganisationConfiguration = () => {

	// Nothing is read from this any more, but the call is kept so the subscription
	// and the hook order stay exactly as they were.
	useOutletContext();


	return (
		<Fragment>
            <AdministrationHeader
				title="Configuration"
                subTitle=""
				className="text-text-3"
				icon={icon({name: "wrench", style: "light"})}
			/>
			<div className="text-left flex flex-auto flex-col ml-10 border-solid border-border">
				<div className="pt-4 pb-2 my-2 rounded-lg h-screen flex flex-auto flex-col">
                    
				</div>
			</div>
		</Fragment>
	);
};

export default OrganisationConfiguration;
